import React, { useEffect, useRef, useCallback, useMemo } from "react"
import currencyFormat from "scripts/utils/currencyFormat"

const useShowHide = (ref, isVisible) => {
  useEffect(() => {
    if (isVisible) {
      ref.current.classList.remove("hideC")
      ref.current.classList.add("showC")
    }
  }, [ref, isVisible])
}

const Buy = React.memo(
  function Buy({ product, goCart, goReserve }) {
    const ref = useRef(null)
    const phrases = window.phrases || {}
    useShowHide(ref, !!product)

    const isItemInCart = product && product.in_cart

    const isShowOldPrice = useMemo(
      () => product && product["old_price"] !== product.price,
      [product],
    )

    const addToCartButtonClickHandler = useCallback(() => {
      if (!isItemInCart) {
        const buyBtn = document.querySelector(".js_fixed_product_buy span")
        if (buyBtn) {
          if (window.productsIDs.includes(product.id)) {
            window.productsIDs = window.productsIDs.filter(
              (id) => id !== product.id)
          }
          buyBtn.dispatchEvent(
            new CustomEvent("click", {
              bubbles: true,
              detail: {
                productVariantId: product.id,
              },
            }),
          )
        }
      } else {
        const cartBtn = document.querySelector("[data-target=modal-cart].modal-btn")
        if (cartBtn) {
          cartBtn.dispatchEvent(
            new CustomEvent("click", {
              bubbles: true,
            }),
          )
        }
      }
      goCart()
    }, [product?.id, goCart])

    const reserveButtonClickHandler = useCallback(() => {
      goReserve()
    }, [goReserve])

    return (
      <div className="store-selector__product-card flex-c-b ">
        <div ref={ref} className="store-selector-product-card flex-c hideC">
          <div className="store-selector-product-card__img flex-c-c">
            <img src={product?.image} alt={product?.name} />
          </div>

          <div className="store-selector-product-card__content">
            <div className="store-selector-product-card__info">
              <div className="code flex-c">
                <div className="title">
                  {phrases.checkout.productProps.article || "Article"}:
                </div>
                <div className="num">{product?.["vendor_code"]}</div>
              </div>
              <ul className="store-selector-product-card__sizes flex-c">
                {product?.properties?.size && (
                  <li className="flex-c">
                    <div className="title">
                      {phrases.checkout.productProps.size || "Size"}:
                    </div>
                    <div className="num">{product.properties.size}</div>
                  </li>
                )}
                {product?.properties?.["weight_product"] && (
                  <li className="flex-c">
                    <div className="title">
                      {phrases.checkout.productProps.weight || "Weight"}:
                    </div>
                    <div className="num">
                      {product?.properties?.["weight_product"]}{" "}
                      {phrases.product?.["weight_uom"] || "g"}
                    </div>
                  </li>
                )}
              </ul>
              <div className="store-selector-product-card__price">
                <span className="price__current">
                  <span className="num">
                    {product && currencyFormat(Number(product.price))}
                  </span>
                  <span className="currency">&nbsp;₴</span>
                </span>
                {isShowOldPrice && (
                  <span className="price__old">
                    <span className="num">
                      {product && currencyFormat(Number(product["old_price"]))}
                    </span>
                    <span className="currency">&nbsp;₴</span>
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="store-selector-card-btn">
          <button
            type="button"
            disabled={!product}
            onClick={addToCartButtonClickHandler}
            className="wb-btn btn-white add-to-basket"
          >
            {isItemInCart
              ? phrases.cart?.["in_basket"]
              : phrases.product?.["buy_button_title"] || "Add to Basket"}
          </button>
          <button
            type="button"
            disabled={!product}
            onClick={reserveButtonClickHandler}
            className="wb-btn btn-light-green reserved"
          >
            {phrases.product?.["buy_book_button_title"] || "Make a reservation"}
          </button>
        </div>
      </div>
    )
  },
  (prevProps, nextProps) => {
    return prevProps.product?.id === nextProps.product?.id
  },
)

export default Buy
